import React, { Component } from "react";
import { Button, ControlLabel, Modal,FormControl, Glyphicon, ListGroup, ListGroupItem, Tooltip, OverlayTrigger, Col } from "react-bootstrap";
import NumberFormat             from 'react-number-format';
import uniqueId                 from 'lodash/uniqueId';
import AutoSuggest              from "../../components/autosuggest/AutoSuggest";
import DropdownMeasure          from "../../components/form/DropdownMeasure";
import DropdownPrescription     from "../../components/form/DropdownPrescription";
import FreeFormTextArea         from "../../components/form/FreeFormTextArea";
import LoaderButton             from "../../components/LoaderButton";
import { ExerciseFreeFormId }   from "../../utils/StaticIds";
import { Colors }               from "../../utils/Colors";
import ModalAlert               from "../../components/modal/ModalAlert";
import YouTubeThumbnail         from "../../components/YouTubeThumbnail";
import { invokeGetProgramDayViewExerciseDetails } from "../../utils/AwsInvoke";
import "../../css/modal/ModalSimple.css";

var textInput = null;
var exercise_name;  // use component based var because if alert modal shows, it clears the exercise name/id
var exercise_id;
const tooltipSetsLabel = ( <Tooltip id="tooltip">
                                You have up to 10 sets to add measurements. Add as many or as few sets as you would like.
                           </Tooltip> );
const tooltip = (
    <Tooltip id="tooltip">Notes are attached to this program only.</Tooltip>
);

var emptyMetricsTemplate = [[1,2,3,4,5,6,7,8,9,10],["","","","","","","","","",""],["","","","","","","","","",""],["00:00","00:00","00:00","00:00","00:00","00:00","00:00","00:00","00:00","00:00"]];

export default class ModalSimple extends Component {

    constructor(props) {
        super(props);

        var modalSimpleAction = this.props.modalSimpleAction

        var show_text_fields    = "inherit";
        var show_freeform_field = "none";
        var show_notes_field    = "none";
        var note_label          = "Notes";

        if(modalSimpleAction === "freeFormNewBlock" || modalSimpleAction === "freeFormEditBlock" || modalSimpleAction === "freeFormEditBlockFromMonthView") {
            show_text_fields    = "none";
            show_freeform_field = "inherit";
            note_label          = "Free-Form"
        }

        var selected_search_option = localStorage.getItem('modal_simple_search_exercise_options');

        if(selected_search_option == null) selected_search_option = 'search_title'

        this.state = {
            //showModalSimple:  false,
            exercise_index:      null,
            openQuickFill:       false,
            show_text_fields:    show_text_fields,
            show_freeform_field: show_freeform_field,
            show_notes_field:    show_notes_field,
            note_label:          note_label,
            carouselIndex: 0,
            carouselDirection: null,
            rest: 0,
            exercise_start:    "",
            exercise_execute:  "",
            exercise_focus:    "",
            exercise_goal:     "",
            addNotesContainer: "inline",
            //simpleBox:        false, // current_tab = 1
            current_tab:      "1", //  simplebox = false
            showExerciseLoadingText: "none",
            showModalAlert:   false,
            rowBoxMetrics: [],
            keywords:   [],
            keywords_list: [],
            displayKeywordList: "none",
        };
    }



    /* RADIO BUTTON SAMPLE
    <label className="keywordsExercRadioBtns1">
          <input type="radio"
                 value="search_title"
                 checked={this.state.selectedSearchOption === 'search_title'}
                 onChange={this.handleOptionChange} />
             <span className="radioBtnKeywordsExerciseLabel">Search by Title</span>
    </label>

    handleOptionChange = (event) => {
        var option = event.target.value;
        localStorage.setItem('modal_simple_search_exercise_options', option);
        this.setState({
            selectedSearchOption: option,
        });
    }*/


    handleOpenModalSearchKeywords = () => {
        this.props.handleOpenModalSearchKeywords();
    }

    componentWillMount() {
        var current_tab = "2";
        var rest = this.props.rest;
        if(rest === null) rest = 0;

        var curr_exerc_id  = this.props.exercise_id;
        var adv_met        = this.props.advanced_metrics;
        var exercise_notes = this.props.exerciseNotes;
        var day_view       = this.props.showDayView;
        //// Defaults in the Monthview but if it's Dayview, then switch the exerc notes value to the below
        var exercise_note  = this.props.exerciseNotes; // exercise_note = "";
        var exercise_lgth  = 0;
        var adv_arr = [];
        var max_col_num = 0;

        if(curr_exerc_id != ExerciseFreeFormId) {
            //console.log("adv_met[1]: " + adv_met[1]);

            // Element [0] is the first measure row, which is static, not used and unreliable (gives misleading row numbers)
            if(adv_met[1] != undefined)
                max_col_num = adv_met[1].length-1; // There's an ERROR here sometimes and if adv_met[1] = undefined, then no columns will display for any exercise  //
        } else {
            //console.log("IT's a FREE-FORM Exercise. Don't need a max_col_num.");
        }

        ////  MONTH VIEW FUNCTIONALITY  ////
        if(exercise_notes == undefined) {
            exercise_note = "";
        } else
            exercise_note = exercise_notes;

        ////  DAY VIEW FUNCTIONALITY  ////
        if(exercise_notes != undefined && exercise_notes != "") exercise_lgth  = exercise_notes.length;
        if(exercise_lgth > 0 && day_view == "inherit") {
            //// DAY VIEW functionality: This loop runs through all the exercises in the day and determines which ones have a note associated with
            //// them and which ones don't; if there's a note, then show an icon and associate the note with the exercise id
            for(var e=0; e < exercise_lgth; e++) {
                var tmp_exercise_id = exercise_notes[e].exercise_id;
                if(curr_exerc_id === tmp_exercise_id) {
                    exercise_note = exercise_notes[e].notes;
                    break;
                } else
                    exercise_note = "";
            }
        }

        for(var l=0; l < 10; l++) {
            var val;
            if(adv_met != null) {
                    if(adv_met[0] != undefined) {
                        if(adv_met[0][l] == undefined) {
                            val = l+1; //adv_met[0][l] = l+1;
                        } else {
                            val = l+1;;//adv_met[0][l];
                            //max_col_num = l;
                        }
                    } else {
                        val = l+1;
                        //max_col_num = l+1;
                    }

                    adv_arr.push(val);// adv_met[0][l]);
            }
        }

        if(adv_met != null) {
            if(adv_met != "" && adv_met[0] != undefined)
                adv_met[0] = adv_arr;
            else if(adv_met === "" )
                adv_met = emptyMetricsTemplate;
        }
        exercise_name = this.props.exercise_name;
        exercise_id   = this.props.exercise_id;

        this.setState({
            current_tab:      current_tab, //  simplebox = false
            //exercise_id:     this.props.exercise_id,
            //exercise_name:   this.props.exercise_name,
            maxColNum:        max_col_num,
            rest:             rest,
            notes:            this.props.notes,
            measure_adv_row1: this.props.measure_adv_row1,
            measure_adv_row2: this.props.measure_adv_row2,
            measure_adv_row3: this.props.measure_adv_row3,
            measure_adv_row4: this.props.measure_adv_row4,
            youtube_id:       this.props.youtube_id,
            exerciseNotes:    exercise_note, //temp remove 11.17.10: exercise_note,
            rowBoxMetrics:    adv_met, // 30 seconds
            isTemplate:       this.props.isTemplate
        });
    }

    componentWillReceiveProps (nextProps) {
        var measure_adv_row2  = nextProps.measure_adv_row2;
        var measure_adv_row3  = nextProps.measure_adv_row3;
        var new_exercise_id   = nextProps.exercise_id;
        var new_exercise_name = nextProps.exercise_name;

        ////  Used when Category Search is used  ////
        ////  If category modal is open then cancelled, and another exercise is not selected,
        ////  ensure the previously selected exercise is still displayed and not cancelled;
        ////  exercise_name/exercise_id is a class var
        if(new_exercise_id != 0) {
            exercise_name = new_exercise_name;
            exercise_id   = new_exercise_id;
        }

        this.setState({
            measure_adv_row2: measure_adv_row2,
            measure_adv_row3: measure_adv_row3,
            exercise_id:      new_exercise_id,
            exercise_name:    new_exercise_name
        })
    }

    componentWillUnmount() {
        // Reset Input Values
        this.setState({
            exercise_id:     0,
            exercise_name:   "",
            exerciseNotes:   "",
            measure_a_id:    0,
            measure_a_value: 0,
            measure_b_id:    0,
            measure_b_value: 0,
            rest:            0,
            measure_adv_row1: [],
            measure_adv_row2: [],
            measure_adv_row3: [],
            measure_adv_row4: [],
            youtube_id:       "",
            rowBoxMetrics:    [],
            notes:            "",
            maxColNum:        0
        });
    }

    handleMeasureAIdChange(value) {

        this.setState({
            measure_a_id: value
        });
    }

    handleMeasureBIdChange(value) {
        this.setState({
            measure_b_id: value
        });
    }

    handleMeasureAChange(event) {
        this.setState({
            measure_a_value: event.target.value
        });
    }

    handleMeasureBChange(event) {
        this.setState({
            measure_b_value: event.target.value
        });
    }

    handleRestChange(event) {
        this.setState({
            rest: event.target.value
        });
    }

    handleNotesChange(value) {
        // other option: show_notes_field = "inherit"
        if(this.state.show_freeform_field === "inherit")
            this.setState({ notes: value});
        else
            this.setState({ exerciseNotes: value});
    }

    handleExerciseChange(id, name, yt_id) {
        exercise_name = name;
        exercise_id   = id;
        this.setState({
            exercise_id: id,
            youtube_id: yt_id
            //exercise_name: name,
        });
    }

    handleMeasureAdvancedRow1Change(value) {
        this.setState({
            measure_adv_row1: value
        });
    }

    //// Default is "SETS" column ////
    handleMeasureAdvancedRow2Change = (id) => {
        this.setState({
            measure_adv_row2: id
        });
    }

    //// Default is "REPS" column ////
    handleMeasureAdvancedRow3Change = (id) => {

        if(id == 100) {
            var max_col_num = this.state.maxColNum+1;
            var arr = this.state.rowBoxMetrics;

            //// INSERT VALUE INTO TEXTFIELD BUT IF ID = "NONE", CHANGE ALL VALUES TO 0 ////
            for(var i=0; i< 4;i++)
                for(var j=0; j< 10;j++)
                    if(i === 2 && j < max_col_num) arr[i][j] = 0;


            this.setState({
                measure_adv_row3: id,
                rowBoxMetrics: arr //[[3,3,3],[12,12,12],[.6,.6,.6],[30,30,30]]
            })
        } else {
            this.setState({
                measure_adv_row3: id
            });
        }

    }

    submitAdvancedForm () {
        var block_index    = this.props.block_index;
        var exercise_index = this.props.exercise_index;
        var exercise_notes = this.state.exerciseNotes;
        var row_1_id       = this.state.measure_adv_row1;
        var row_2_id       = this.state.measure_adv_row2;
        var row_3_id       = this.state.measure_adv_row3;
        var row_4_id       = this.state.measure_adv_row4;
        var row_1_arr      = [];
        var row_2_arr      = [];
        var row_3_arr      = [];
        var row_4_arr      = [];

        //console.log("--------------- SUBMIT -------------");

        var col_stop      = 11; // there are only 10 tfs
        var col_empty_min = 11;

        // Check where there's an empty textfield and use as a Column Stop (ie insert data only to non-empty columns)
        for(var prerow = 1; prerow < 5; prerow++){
            for(var precol = 0; precol < 10; precol++) {
                var rows = "row_"+prerow+"_" + precol;
                var val = this.state[rows];
                if(val === "") {
                    // Get the minimum empty textfield colun
                    if(precol < col_stop) {
                        col_stop = precol;
                    }
                }
            }
        }

        //// Skip Row 1 Since it's only static Set Information
        for(var row = 1; row < 5; row++){

            for(var i = 0; i < 10; i++) {
                var rows = "row_"+row+"_" + i;
                var val = this.state[rows];

                // Catch null and empty vals; do not add to final arr
                if(val != undefined && i < col_stop) { // rem: 'val != "" &&' because it hides '0' values
                    var i_ctr = parseInt(i+1);

                    if(row === 1) {
                        row_1_arr.push(i_ctr); // save set #
                    } else if(row === 2) {
                        row_2_arr.push(val)
                    } else if(row === 3) {
                        row_3_arr.push(val)
                    }
                    else {
                        //console.log("row 4 val: " + val);
                        // Rest Section - var mmss = val.toString();var secs = this.getSeconds(mmss);row_4_arr.push(secs); */
                        row_4_arr.push(val);
                    }
                }
            }
        }

        if(row_2_arr == 0 && row_3_arr == 0) {
            this.setState({
                isLoading: false
            }, function(){
                this.showAlertModal("Your exercise could not be saved: <br>⁃ Make sure there are no empty text fields.<br>⁃ Make sure the number 0 is not prescribed.");
            })
        } else {
            //this.props.showProgressOverlay(1); // immediately show overlay
            var modalSimpleAction = this.props.modalSimpleAction;

            if(modalSimpleAction === "edit" || modalSimpleAction === "freeFormEditBlock")
                this.props.handleEditAdvancedExercise(block_index, exercise_index, exercise_id, exercise_name, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, exercise_notes);
            else if(modalSimpleAction === "editFromMonthView")
                this.props.handleEditAdvancedExerciseMonthView(block_index, exercise_id, exercise_name, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, exercise_notes);
            else
                this.props.handleAddAdvancedExercise(block_index, exercise_id, exercise_name, row_1_id, row_2_id, row_3_id, row_4_id, row_1_arr, row_2_arr, row_3_arr, row_4_arr, exercise_notes);

            //this.props.onHide(); // Close Modal // don't close prematurely, only close after data has been set in the db
        }
    }

    submitFreeForm () {
        var modalSimpleAction = this.props.modalSimpleAction;

        var block_index    = this.props.block_index;
        var exercise_index = 0;// since all free-forms are the only exercises in a block, it's a 0; this.props.exercise_index;
        var exercise_id    = ExerciseFreeFormId; // permanent id
        var notes          = this.state.notes;

        if(modalSimpleAction === "freeFormEditBlockFromMonthView") {
            this.props.handleEditAdvancedExerciseMonthView(block_index, exercise_id, "exercise_name", 0, 0, 0, 0, 0, 0, 0, 0, notes);
        } else {
            this.props.handleAddFreeFormExercise(block_index, exercise_index, exercise_id, notes);
        }
    }

    checkIfThereAreEmptyTFs = () => {
            var arr         = this.state.rowBoxMetrics;
            var max_col_num = this.state.maxColNum+1;
            var empty_tf    = false;

            //// CHECK IF THERE's AN EMPTY TEXTFEILD IN THE MATRIX ////
            for(var i=0; i< 4;i++){
                for(var j=0; j< 10;j++){
                        if(i != 0 && i != 3 && j < max_col_num) {
                            //console.log("Row_" + i + "_" + j + "arr: " + arr[i][j])
                            var val = arr[i][j];
                            if(val === "" || val === undefined)
                                empty_tf = true;
                        }
                }
            }

            return empty_tf;
    }

    handleSubmit() {
        // this clears the exercise name: this.props.showProgressOverlay(1); // immediately show overlay
        this.setState({ isLoading: true });
        var show_freeform_field  = this.state.show_freeform_field;
        var show_notes_field     = this.state.show_notes_field;
        var exercise_index       = this.props.exercise_index;
        //var exercise_id          = this.state.exercise_id;   // no longer using state
        //var exercise_name        = this.state.exercise_name; // no longer using state

        if(exercise_id != "") {
            //// ALERT Stating an "Exercise title" is required
            if(show_freeform_field === "inherit") {
                this.submitFreeForm();
                //this.props.onHide(); // Close Modal //
            } else {
                var empty_tfs = this.checkIfThereAreEmptyTFs();

                if(!empty_tfs)
                    this.submitAdvancedForm();
                else {
                    this.showAlertModal("Sorry, you can't have an empty textfield.");
                    this.setState({ isLoading: false });
                }
            }
        } else {
            this.showAlertModal("You need to select an exercise.");
            this.setState({ isLoading: false });
        }
    }

    showAlertModal (body_text) {

        this.props.showProgressOverlay(0); // hide overlay
        this.setState({
            modalAlertTitleText: "Warning",
            modalAlertBodyText:  body_text,
            showModalAlert:      true,
            alertObject:         {}, // not req'd unless deleting program or folder
            alertAction:         ""  // not req'd unless deleting program or folder
        })
    }

    handleChangeSetsReps (sets, reps, rest) {
        this.setState({
            measure_a_value: sets,
            measure_b_value: reps,
            rest:            rest,
            openQuickFill:   false
        })
    }

    async handleCarouselNext () {
        //var exercise_id = this.state.exercise_id;

        if(exercise_id != "") {
                this.setState({
                    showExerciseLoadingText: "inline"
                });

                try {
                    const results = await invokeGetProgramDayViewExerciseDetails(exercise_id);

                    var start   = "";
                    var execute = "";
                    var focus   = "";
                    var goal    = "";
                    var yt_id   = "";

                    if(results[0] != undefined) {
                        start   = results[0].start;
                        execute = results[0].execute;
                        focus   = results[0].focus;
                        goal    = results[0].goal;
                        yt_id   = results[0].youtube_id;
                    }

                    this.setState({
                        carouselIndex: 1,
                        carouselDirection: "next", // next || prev
                        exercise_start:    start,
                        exercise_execute:  execute,
                        exercise_focus:    focus,
                        exercise_goal:     goal,
                        youtube_id:        yt_id,
                        showExerciseLoadingText: "none"
                    });
                } catch (e) {
                    alert("Carousel: " + e);
                    this.setState({
                        showExerciseLoadingText: "none"
                    });

                }
        } else {
            this.showAlertModal("You need to select an exercise.");
        }
    }

    async handleCarouselNextAddNote () {
        //var exercise_id = this.state.exercise_id;
        var show_text_fields = "none";
        var show_notes_field = "inherit";
        var note_label       = "Notes"

        if(exercise_id != "") {
                this.setState({
                    showExerciseLoadingText: "inline"
                });

                try {
                    /*const results = await invokeGetProgramDayViewExerciseDetails(exercise_id);

                    const start   = results[0].start;
                    const execute = results[0].execute;*/

                    this.setState({
                        carouselIndex: 2,
                        carouselDirection: "next", // next || prev
                        showExerciseLoadingText: "none",
                        addNotesContainer:   "none",
                        show_notes_field:    show_notes_field,
                        show_text_fields:    show_text_fields,
                        note_label:          note_label,

                    });
                } catch (e) {
                    alert(e);
                    this.setState({
                        showExerciseLoadingText: "none"
                    });

                }
        } else {
            alert("You need to select an exercise.")
        }
    }

    handleCarouselBack () {
        this.setState({
          carouselIndex: 0,
          carouselDirection: "prev", // next || prev
        });
    }

    handleCarouselNotesBack () {
        this.setState({
            carouselIndex: 0,
            addNotesContainer:   "inherit",
            show_freeform_field: "none",
            show_notes_field:    "none",
            show_text_fields:    "inherit",
            note_label:          "Free-Form"
        });
    }

    handleSelectCarousel(selectedIndex, e) {
        //alert(`selected=${selectedIndex}, direction=${e.direction}`);
        this.setState({
          carouselIndex: selectedIndex,
          carouselDirection: e.direction, // next || prev
        });
    }

    createExerciseDetailsCarousel (video_src) {

        var start   = this.state.exercise_start; //.replace(/\\r\\n/g,' '); // removeall occurrences of \r\n
        var focus   = this.state.exercise_focus; //.replace(/\\r\\n/g,' ');
        var execute = this.state.exercise_execute; //.replace(/\\r\\n/g,' ');
        var goal    = this.state.exercise_goal; //.replace(/\\r\\n/g,' ');

        if(start != null) {
            start   = start.replace(/\\r\\n/g,' '); // removeall occurrences of \r\n
            start   = start.replace(/-\s/, "<li type='disc'>");
            start   = start.replace(/\s-\s/g, "</li><li  type='disc'>"); // replace space and hyphen
        } else start = "None.";
        if(focus != null) {
            focus   = focus.replace(/\\r\\n/g,' '); // removeall occurrences of \r\n
            focus   = focus.replace(/-\s/g, "<li type='disc'>");
            focus   = focus.replace(/-\s/g, "</li><li  type='disc'>"); // replace space and hyphen
        } else focus = "None.";
        if(execute != null) {
            execute = execute.replace(/\\r\\n/g,' ');
            execute = execute.replace(/-\s/g, "<li type='disc'>");
            execute = execute.replace(/-\s/g, "</li><li  type='disc'>"); // replace space and hyphen
        } else execute = "None.";
        if(goal != null) {
            goal    = goal.replace(/\\r\\n/g,' ');
            goal    = goal.replace(/-\s/g, "<li type='disc'>");
            goal    = goal.replace(/-\s/g, "</li><li  type='disc'>"); // replace space and hyphen
        } else goal = "None.";

        var item = <div >
                        <div className="exerciseDetailContainer"
                             id="exercDetailScroller">
                              <div className="youTubeExercisePlayerContainer">
                                   <iframe className="player"
                                           type="text/html"
                                           width="100%"
                                           height="200px"
                                           style={{width: "100%"}}
                                           allowFullScreen
                                           src={video_src}
                                           frameBorder="0"/>
                              </div>
                              <div>
                                  <b>START</b>
                                    <div dangerouslySetInnerHTML={this.createMarkup(start)} />
                                    <br/>
                              </div>
                              <div>
                                  <b>EXECUTE</b>
                                <div dangerouslySetInnerHTML={this.createMarkup(execute)} />
                                <br/>
                              </div>
                              <div>
                                  <b>FOCUS</b>
                                  <div dangerouslySetInnerHTML={this.createMarkup(focus)} />
                                    <br/>
                              </div>
                              <div>
                                  <b>GOAL</b>
                                <div dangerouslySetInnerHTML={this.createMarkup(goal)} />
                                <br/>
                              </div>
                        </div>
                    </div>

        return item;
    }

    createMeasureRow (row_num, measure_arr) {
        // test if(row_num === 4) console.log("TEST measure_arr: " + measure_arr);
        // Values are coming through but are not being shown on the textfield!!!
        // measure_arr shows inputted values

        var measures    = []; // = [0,0,0,0,0,0,0,0,0,0];
        var numb_of_tfs = 10;
        var m_lgth;

        if(measure_arr == null || measure_arr == "") {
            m_lgth = 0;
        } else m_lgth = measure_arr[0].length;

        for(var m = 0; m < numb_of_tfs; m++) {
            var m_0 = 0;
            var m_1 = 0;
            var m_2 = 0;
            var m_3 = 0;

            //if(measure_arr != null && measure_arr[m] != undefined) {
            // Show Textfield Values
            if(m < m_lgth) {
                if(measure_arr[0] != undefined) {
                    m_0 = measure_arr[0][m];
                    //console.log("Row 1: " + measure_arr[0][m]);
                }

                if(measure_arr[1] != undefined) {
                    m_1 = measure_arr[1][m];
                    //console.log("Row 2: " + measure_arr[1][m]);
                }

                if(measure_arr[2] != undefined) {
                    m_2 = measure_arr[2][m];
                    //console.log("test row 3: " + measure_arr[2][m]);
                }
                if(measure_arr[3] != undefined) {
                    m_3 = measure_arr[3][m];
                    //console.log("test row 4: " + measure_arr[3][m]);
                }
                //if(m_3 === undefined) m_3 = "00:00"
            }

            //12/14 rem: if(m_0 > 0 && row_num === 1) {
            if(m_0 >= 0 && row_num === 1) {
                measures.push(m+1); //(Number(m+1))

            //} else if(m_1 >= 0 && row_num === 2) {
            } else if(m_1 != undefined && row_num === 2) {
                measures.push(m_1); //Number(m_1))

            //} else if(m_2 >= 0 && row_num === 3) {
            } else if(m_2 != undefined && row_num === 3) {
                //id: 12 = Percent of Max (%)
                /*/* temp remove: inputting decimal points is outputting incorrectly
                if(id === 12) {
                    console.log("% of max hit!");
                    // change decimal to %
                    m_2 = 100*m_2;
                }*/

                measures.push(m_2)
            } else if(row_num === 4) { //m_3 >= 0 &&
                //var time = m_3;
                //if(isNaN(val)) val = "";
                //measures.push(m_3)
                /*if(m_3 >= 60) {
                    console.log("time: " + time);
                    var minutes = Math.floor(time / 60);
                    var seconds = time - minutes * 60;
                    console.log("minutes: " + minutes);
                    console.log("seconds: " + seconds);
                }
                var new_m_3 = minutes+""+seconds //this.convertMMSS(m_3);
                console.log("this.convertMMSS(m_3): " + new_m_3);*/
                //console.log("M 3: " + m_3);
                //console.log("--------");
                if(m_3 === undefined || m_3 == 0 )
                    m_3 = "00:00";

                measures.push(m_3)
            } else {
                // Push Empty Elements
                measures.push("");
            }
        }

        var that = this;
        var max_col_num = this.state.maxColNum;

        var row_data = measures.map(function (value, index, array) {
            var name = "row_"+row_num+"_"+(index++);
            var inputBox;
            var border = "";
            var border_left = "";

            that.state[name] = value; // don't invoke parseInt() since there are decimals used in certain metrics

            //// ADD GRAY/GREEN OUTLINE OF ACTIVE TF VALUES ////
            //if(((row_num === 2 && value != "") || (row_num === 3 && value != "")) || max_col_num+2 > index) { // max_col_num+2: in case user selects a column that has empty rows before it
            if(max_col_num+2 > index) {
                var border_color = Colors.primary_color;
                if(row_num === 1) border_color = "#bbb";

                border = "2px solid " + border_color;
                if(index === 1) border_left = "3px solid " + border_color;
                    else border_left = "1px solid " + border_color;
            }

            if(row_num != 4) {
                 inputBox = <FormControl key       = {name} //dont use uniqueId() otherwise tf loses focus onChange
                                         type      = "text"
                                         value     = {value}
                                         onChange  = {that.handleTFRowChange.bind(that)}
                                         name      = {name}
                                         maxLength = "5"
                                         ref       = {(input) => { textInput = input }}
                                         style     = {{border, borderLeft: border_left}}
                                         className = "twoCharInputBox" />
            } else {
                 //// REST SECTION ////
                 if(value === 0) value = "00:00";

                 inputBox = <NumberFormat key       = {index}
                                          format    = "##:##"
                                          value     = { value }
                                          onChange  = {that.handleTFRowChange.bind(that)}
                                          name      = {name}
                                          ref={(input) => { textInput = input }} //name = input
                                          //placeholder="mm:ss"
                                          //mask={['m', 'm', 's', 's']}
                                          style     = {{border, borderLeft: border_left}}
                                          className = "twoCharMMSSInputBox" />
            }

            return inputBox
        });

        return row_data
    }

    handleTFRowChange (evt) {

        var   value     = evt.target.value;
        const row_name  = evt.target.name;

        var regex = value.match(/^.+:\d+$/); // is REST value formatted correctly?

        ////  Only allow Numerical Values; DO NOT allow any letters  ////
        if (!value || value.match(/^\d{1,}(\.\d{0,4})?$/) || regex != null) {

                var row_2_id       = this.state.measure_adv_row2;
                var row_3_id       = this.state.measure_adv_row3;

                const row_num = Number(row_name.substring(4,5)) - 1;
                var   col_num = Number(row_name.substring(6));

                var arr = this.state.rowBoxMetrics;

                //// INSERT VALUE INTO TEXTFIELD via MultiDimen Array ////
                for(var i=0; i< 4;i++){
                    for(var j=0; j< 10;j++){
                        if(row_num === i && col_num === j) {
                            // catch undefined values otherwise an error will occur
                            if(arr[i] != undefined) {
                                arr[i][j] = value;

                            }
                        }
                    }
                }

                var max_col_number = this.getMaxColNumber(arr);

                this.setState({
                    maxColNum: max_col_number,
                    rowBoxMetrics: arr //[[3,3,3],[12,12,12],[.6,.6,.6],[30,30,30]]
                })
         }
    }

    getMaxColNumber = (arr) => {
        //// Check which max column (1-10) has a textfield and value in it ////
        var max_col_number = 0;
        for(var i=0; i< 4;i++){
            for(var j=0; j< 10;j++){
                // catch undefined values otherwise an error will occur
                if(arr[i] != undefined) {
                    if(arr[i][j] != undefined && arr[i][j] != "" && i != 0 && i != 3) {
                        if(max_col_number < j)  max_col_number = j;
                    }
                }
            }
        }

        return max_col_number;
    }

    createAdvancedBox () {
        var arr = this.state.rowBoxMetrics;

        var row1 = this.createMeasureRow(1, arr);
        var row2 = this.createMeasureRow(2, arr);
        var row3 = this.createMeasureRow(3, arr);
        var row4 = this.createMeasureRow(4, arr);

        return <span className="advancedBoxContainer">

                    { /*}<Col componentClass={ControlLabel}
                         xs={1} sm={2} md={3}
                         className="row1MeasureAdvancedContainer"
                    >
                        { /*}<DropdownMeasure id={this.state.measure_adv_row1}
                                         changeId={(value) => this.handleMeasureAdvancedRow1Change(value)}
                        />* / }
                        <span className="row1MeasureAdvancedTitle">
                            Sets
                            <OverlayTrigger placement="top" overlay={tooltipSetsLabel} >
                                <Glyphicon glyph="question-sign" className="tooltipIcon" style={{position:"relative", top:"3px", left:"5px", color:"#ddd"}}/>
                            </OverlayTrigger>
                        </span>
                        <div className="row1MeasureContainer">
                            { row1 }
                        </div>
                    </Col> */}
                    <span className="dropdownMeasure1a_xpos">
                        Sets
                        <OverlayTrigger placement="top" overlay={tooltipSetsLabel} >
                            <Glyphicon glyph="question-sign" className="tooltipIcon" style={{position:"relative", top:"3px", left:"5px", color:"#ddd"}}/>
                        </OverlayTrigger>
                    </span>
                    <div className="dropdownMeasure1b_xpos">
                        { row1 }
                    </div>
                    { /*}<br/><br/><br/><br/>*/ }
                    <div className="dropdownMeasure1c_xpos">
                        <DropdownMeasure id={this.state.measure_adv_row2}
                                         showNoneOption = {0}
                                         changeId={this.handleMeasureAdvancedRow2Change.bind()}
                        />
                    </div>
                    <div className="dropdownMeasure1d_xpos">
                        { row2 }
                    </div>

                    { /****************** ROW 3 ******************/ }
                    <div className="dropdownMeasure1e_xpos">
                        <DropdownMeasure id={this.state.measure_adv_row3}
                                         showNoneOption = {1}
                                         changeId={this.handleMeasureAdvancedRow3Change.bind()}
                        />
                    </div>
                    <div className="dropdownMeasure1f_xpos">
                        { row3 }
                    </div>

                    { /****************** ROW 4 ******************/ }
                    <span disabled className="glyphButton restAdvancedBo dropdownMeasure1g_xpos">
                        <Glyphicon glyph="time" />
                        <span className="restAdvancedBoxTitle">Rest (mm:ss)</span>
                    </span>
                    <br/>
                <div className="row4MeasureContaine dropdownMeasure1h_xpos ">
                        { row4 }
                    </div>
                    <br/><br/><br/>
               </span>
    }

    changeDropdownId = (presciption_arr, row2_dd_id, row3_dd_id) => {
        var max_col_number = this.getMaxColNumber(presciption_arr);

        this.setState({
            maxColNum: max_col_number,
            rowBoxMetrics: presciption_arr,
            measure_adv_row2: row2_dd_id,
            measure_adv_row3: row3_dd_id
        });
    }

    createMarkup(text) { return {__html: text}; };

    handleOpenExerciseMatrix = () => {
        this.props.handleOpenExerciseMatrix();
    }

    render() {

        var block_index     = this.props.block_index;
        //var exercise_id     = this.state.exercise_id;
        //var exercise_name   = this.state.exercise_name;
        var rest            = this.state.rest; //not props.rest
        var notes           = this.props.notes;
        var trainer_notes   = this.state.exerciseNotes;

        var simpleOrAdvancedBox   = <span></span>;
        var show_freeform_field   = this.state.show_freeform_field;
        var show_notes_field      = this.state.show_notes_field;
        var video_id              = this.state.youtube_id;// "mYFaghHyMKc";
        var display_notes_field   = "none";
        var add_notes_container   = this.state.addNotesContainer;
        var current_notes         = this.state.notes;
        var video_src             = "https://www.youtube.com/embed/" + video_id + "?autoplay=0&rel=0&modestbranding=1";
        var dropdownPrescription;
        var free_form_comp;
        var exerciseDetailsCarousel;
        var search_box_details_link_ypos = 2;
        var add_spacer;

        /*if(this.state.selectedSearchOption === 'search_keyword')
            search_box_details_link_ypos = -50;
        else {
            add_spacer = <span style={{display:"inline-block", border: "1px solid #000"}}><br/><br/></span>;
        }*/

        var exercise_matrix = <span className="matrixSearchIcon"
                                    style={{color: Colors.default_blue}}
                                    onClick={() => this.handleOpenExerciseMatrix()}
                              >
                                    Search by Category <span className="glyphicon glyphicon-search searchExerciseCatIcon"/>
                              </span>

        var keywords_link = <div>
                                <div className="keywordsExerciseLabel"
                                     onClick={() => this.handleOpenModalSearchKeywords()}>
                                     Search by Keyword &nbsp;&nbsp; |
                                </div>
                            </div>
        var showDetailsLink  = <span style={{display: this.state.show_text_fields, float: "right", position:"relative", top:"0px", left: "0px"}}>
                                  <span className="showExerciseDetails pull-right"
                                        onClick={this.handleCarouselNext.bind(this)}
                                        style={{position:"absolute", top: search_box_details_link_ypos, left: "-100px", zIndex: 1050}}
                                  >
                                      Details <span className="glyphicon glyphicon-chevron-right"/>
                                  </span>
                               </span>

        if(video_id != undefined)  {
            exerciseDetailsCarousel = this.createExerciseDetailsCarousel(video_src)
        }

        var existing_notes = "";
        if(show_notes_field === "inherit") {
            current_notes = this.state.exerciseNotes; // use exerc notes, not free-form notes
            var notes_lgth = Object.keys(current_notes).length;

            if(notes_lgth <= 1) {
                current_notes = "<p></p>"; // clear exerciseNotes state
            }
        }

        var trainer_lgth = Object.keys(trainer_notes).length; // if there's only 1 char in the object, there's an issue


        if(trainer_notes != null && trainer_notes != "" && trainer_lgth > 1) {
            /*for(var key in trainer_notes) {
                console.log("key: " + key);
                console.log("trainer_notes: " + trainer_notes[key]);
            }*/
            existing_notes = " *this exercise contains notes";
        }

        if(show_freeform_field != "inherit" && show_notes_field != "inherit"){
            simpleOrAdvancedBox  = this.createAdvancedBox();
            dropdownPrescription = <DropdownPrescription changeDropdownId = {this.changeDropdownId} />

        } else if(show_freeform_field === "inherit" || show_notes_field === "inherit"){
            free_form_comp = <div style={{paddingTop:15}}>
                                <FreeFormTextArea handleNotesChange = {this.handleNotesChange.bind(this)}
                                                  notes = {current_notes}/>
                                <br/><br/>
                             </div>
            exercise_matrix  = ""; //clear exercise search icon matrix
            showDetailsLink  = "";
            keywords_link    = "";
            show_notes_field = "inherit";
        }

        var is_template = this.state.isTemplate; // if program is template, hide Add Notes for now
        if(show_freeform_field === "inherit" || is_template === "true" || is_template === "undefined") add_notes_container = "none"; //hide "add notes" link


        var showSlide = <span>
                            { dropdownPrescription }
                            { simpleOrAdvancedBox }
                        </span>

        ////   Carousel Index 1 = Free-form Notes   ////
        if(this.state.carouselIndex === 1) {
               add_notes_container = "none"; // hode notes if user is viewing details
               exercise_matrix = "";
               keywords_link   = "";
               showSlide = <span className="exerciseDetailsCarousel">
                                { exerciseDetailsCarousel }
                           </span>

               showDetailsLink  = <span onClick={this.handleCarouselBack.bind(this)}
                                        className="backExerciseDetails backExerciseDetailsIndex1">
                                      <span className="glyphicon glyphicon-chevron-left "/> Back
                                  </span>
        } else if(this.state.carouselIndex === 2) {
              ///// INDEX 2 is for ATHLETE PERSONAL NOTES
               exercise_matrix  = "";
               keywords_link    = "";
               showDetailsLink  = <span onClick={this.handleCarouselNotesBack.bind(this)}
                                        className="backExerciseDetails backExerciseDetailsIndex2">
                                      <span className="glyphicon glyphicon-chevron-left "/> Back
                                  </span>
        }


        /////////////////////////////////////////////////////////////
        ////////////////////  BEGIN: SEARCH BOX  ////////////////////
        var input_search_box = <span className="modalSimpleAutoSuggest_Box">
                                    <AutoSuggest handleExerciseChange={this.handleExerciseChange.bind(this)}
                                            //defaultValue = {"f"}
                                            clearTextfield = {this.state.clearTextfield}
                                            exercise_id={exercise_id}
                                            exercise_name={exercise_name} >
                                    </AutoSuggest>
                               </span>

       var autosuggest_tf = <span>
                                { input_search_box }
                            </span>

       ////////////////////  END: SEARCH BOX  ////////////////////

       if(show_freeform_field === "inherit") {
          autosuggest_tf = "";
       }

        let closeModalAlert          = () => this.setState({ showModalAlert: false }); //close simple modal window

        return (
            <Modal
                show={this.props.show}
                onHide={this.props.onHide}
              >
                  {this.state.showModalAlert ?
                      <ModalAlert
                          onHide         = {closeModalAlert}
                          alertFunction  = {this.alertFunction}     // custom function to call within modal
                          alertAction    = {this.state.alertAction} // flag used for above function
                          alertObject    = {this.state.alertObject} // vars used for above function
                          showModalAlert = {this.state.showModalAlert}
                          messageTitle   = {this.state.modalAlertTitleText}
                          messageBody    = {this.state.modalAlertBodyText}
                      />
                  : null}

                    <Modal.Header closeButton>
                        <Modal.Title id="contained-modal-title" className="fontSize26px">Exercise & Prescription Selections</Modal.Title>
                    </Modal.Header>
                    <Modal.Body className="exerciseDetailModalBody">
                              <span style={{display: show_notes_field}}>
                                  { autosuggest_tf }

                                  <div className="formLabelBody"> {this.state.note_label} </div>
                                  { free_form_comp }
                                  { showDetailsLink }

                              </span>
                              <div style={{display:this.state.show_text_fields,width:"100%", height:"100px"}}>
                                  { /*}<div className="formLabelBody">Exercise</div>*/ }

                                   {autosuggest_tf}
                                   <div style={{float:"left", position: "absolute", top: 55}}>
                                       {keywords_link}
                                   </div>
                                   <span className="exerciseLoadingDetailsText" style={{display:this.state.showExerciseLoadingText}}>
                                       Loading exercise details...
                                   </span>
                                   {showDetailsLink}
                                   {add_spacer}

                              </div>
                                  { exercise_matrix }

                                <div style={{display:this.state.show_text_fields}}>
                                    <span style={{padding:"15px"}}><br/></span>
                                    { showSlide }
                                 </div>
                              <br/>
                              <div style={{position:"relative", top:"-11px", paddingLeft:"15px", cursor: "pointer", display: add_notes_container}}
                                    className = ""
                                    onClick={this.handleCarouselNextAddNote.bind(this)}>
                                   <Glyphicon glyph="plus-sign" style={{color:"#a2e01c"}}/> Add Notes <b style={{color:"black"}}>{ existing_notes }</b>
                              </div>
                    </Modal.Body>
                    <Modal.Footer style={{position:"relative", top:"0px", height:"75px"}}>
                        <Button className="modalBasicsBtnClose" onClick={this.props.onHide}>Cancel</Button>
                        <span className="modalBasicsFooterXPosSpacer"/>
                        {/*}<Button className="modalBasicsBtnSave" onClick={() => this.handleSubmit()}>Save</Button> */ }
                        <span onClick={() => this.handleSubmit()}>
                            <LoaderButton
                                  //block
                                  bsSize    = "large"
                                  type      = "submit"
                                  className = "modalBasicsBtnSave"
                                  btncolor  = { Colors.ok_button_bg }
                                  fontSize  = {20}
                                  height    = {40}
                                  isLoading = {this.state.isLoading}
                                  text      = "Save"
                                  loadingText = "Saving …"
                              />
                        </span>
                    </Modal.Footer>
              </Modal>


        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modal/ModalSimple.js